import { formatCurrency } from "../../include/money";
import React, { useContext, useEffect, useRef, useState } from 'react';
import { PrintOutlined } from '@mui/icons-material';
import { Box, Button, Container, Typography, TextField, MenuItem, Card } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import GradientLoader from '../../components/CommanComponents/GradientLoader';

import couponArt from '../../assets/luckydraw-front.jpg';
import { QRCodeCanvas } from 'qrcode.react';
import { DataContext } from '../../context/DataContext';
import { callPostApi } from '../../function/ApiCallFunction';

const LuckyDrawCoupon = () => {

    const qrRef    = useRef();
    const navigate = useNavigate();

    const {loginData } = useContext(DataContext);
    const store_id = loginData?.store_info?.store_id || 'STORE';
    const [searchParams, setSearchParams] = useSearchParams();

    const [loading,   setLoading]   = useState(false);
    const [datar,     setDatar]     = useState([]);
    const [cardCount, setCardCount] = useState("");
    const [draws, setDraws] = useState([]);
    const [selected, setSelected] = useState(null);
    const drawId = searchParams.get("draw_id") || "";
    const drawCode = selected?.print_no ? String(Number(selected.print_no)) : "";

    

    //PRINT CONFIG
    const handlePrint = useReactToPrint({
        contentRef: qrRef,
        documentTitle: "QR Cards A3",
        pageStyle: `
          @page { size: A3 landscape; margin: 10mm; }
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            background: white !important;
          }
          .ld-sheet { display: flex !important; flex-wrap: wrap !important; gap: 8mm !important; width: 344mm !important; }
          .ld-card { break-inside: avoid; page-break-inside: avoid; }
        `,
      });

    const generateId = (length = 6) => 
    {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";

      for (let i = 0; i < length; i++) { result += chars.charAt(Math.floor(Math.random() * chars.length)); }
      result = result.toLocaleUpperCase();
      return `${result}`;

    };

    useEffect(() => {
        if (!store_id || store_id === "STORE") return;
        let mounted = true;
        callPostApi("store-draw", { mod: "DRAW_LIST", data_arr: { store_id } }).then((result) => {
            if (!mounted || result.status !== "200") return;
            const rows = result.data?.draws || [];
            setDraws(rows);
        });
        return () => { mounted = false; };
    }, [store_id]);

    useEffect(() => {
        if (!store_id || !drawId) { setSelected(null); return; }
        let mounted = true;
        callPostApi("store-draw", { mod: "DRAW_DETAIL", data_arr: { store_id, draw_id: drawId } }).then((result) => {
            if (!mounted) return;
            setSelected(result.status === "200" ? result.data?.draw || null : null);
        });
        return () => { mounted = false; };
    }, [store_id, drawId]);

    const applyCoupons = () => {
        const count = Math.min(5000, Number(String(cardCount).replace(/\D/g, "")) || 0);
        const printNo = String(Number(String(selected?.print_no || "").replace(/\D/g, "")) || "").padStart(2, "0");
        setLoading(true);
        if (!drawId || selected?.draw_id !== drawId || printNo === "00" || count <= 0) {
            setDatar([]);
            setLoading(false);
            return;
        }
        const list = [];
        for (let i = 1; i <= count; i++) {
            const uniqueId = `${store_id}${printNo}${generateId(6)}`;
            list.push({ id: uniqueId, printNo: String(Number(printNo)) });
        }
        setDatar(list);
        setLoading(false);
    };

    const pickDraw = (value) => {
        setSearchParams(value ? { draw_id: value } : {}, { replace: true });
        setDatar([]);
    };

    const clearFun = () => {
        setCardCount("");
        setDatar([]);
        setSearchParams({}, { replace: true });
    };

  return (
    <Box>
      <Container>

          {/* BACK BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
            <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }} onClick={() => navigate(-1)}> Back </Button>

            <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:'auto'}}
                          onClick={() => navigate('../luckydrawredeem')} > Issued Coupons </Button >          
          </Box>

          {/* TITLE */}
          <Typography variant="h6"  gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
              borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center',}}> <PrintOutlined sx={{ mx: 1 }} /> Print Lucky Draw Coupons
          </Typography>
          
          {/* PRINT BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
                onClick={() => navigate(`../luckydrawcouponQr?draw_id=${drawId}`)} > <PrintOutlined sx={{ mx: 1 }} /> Print QR Only </Button > 

            <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
              onClick={handlePrint} > <PrintOutlined sx={{ mx: 1 }} /> Print Front </Button > 

              <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
                  onClick={() => navigate(`../luckydrawcouponback?draw_id=${drawId}`)} > <PrintOutlined sx={{ mx: 1 }} /> Print Back </Button >           
          </Box>
       
          {/* FILTER */}
          <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>
            <TextField select label="Lucky Draw Coupons" value={drawId} onChange={(e) => pickDraw(e.target.value)} sx={{ minWidth: 260 }}
              helperText={selected ? `Minimum sale ${formatCurrency(selected.min_sale_amount)}` : "1. Select the draw"}>
              <MenuItem value="">Select draw</MenuItem>
              {draws.map((draw) => (
                <MenuItem key={draw.draw_id} value={draw.draw_id}>{draw.print_no ? `${Number(draw.print_no)} · ` : ""}{draw.title}</MenuItem>
              ))}
            </TextField>
            <TextField label="Code" value={drawCode} sx={{ width: 110 }} inputProps={{ readOnly: true }} helperText="2. Draw code in the barcode" />
            <TextField label="Number of coupons" value={cardCount}
              onChange={(e) => {
                const next = e.target.value.replace(/\D/g, "").slice(0, 9);
                setCardCount(Number(next) > 5000 ? "5000" : next);
                setDatar([]);
              }}
              sx={{ minWidth: 180 }} helperText="3. How many to print " />
            <Button variant="contained" sx={{ height: 56, background: 'linear-gradient(195deg, #49a3f1, #1A73E8)' }}
              disabled={!drawId || !drawCode || !(Number(cardCount) > 0)} onClick={applyCoupons}>Apply</Button>
            <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={clearFun}>Clear</Button>
          </Box>
      
          <Box ref={qrRef} className="ld-sheet" sx={{ display: "flex", flexWrap: "wrap", gap: "8mm", width: "344mm", boxSizing: "border-box" }}>

              {datar.length > 0 ? (
                datar.map((item) => {
                  const amount = formatCurrency(selected?.min_sale_amount);
                  return (
                  <Card key={item.id} className="ld-card" sx={{ width: "168mm", height: "84mm", borderRadius: 0, position: "relative", overflow: "hidden", backgroundImage: `url(${couponArt})`,
                        backgroundSize: "100% 100%", backgroundRepeat: "no-repeat", backgroundPosition: "center", boxShadow: "none",
                        border: "1px dashed #9aa3b2", pageBreakInside: "avoid", breakInside: "avoid", }} >

                        <Box sx={{ position: "absolute", left: "63.6%", top: "21.2%", width: "27.4%", height: "10.6%", display: "flex", alignItems: "center", justifyContent: "center", color: "#1a237e", fontWeight: 850, lineHeight: 1, fontSize: amount.length > 7 ? "4.8mm" : "6.2mm", letterSpacing: "0.2mm" }}>
                          {amount}
                        </Box>

                        <Box sx={{ position: "absolute", left: "3.2%", bottom: "4%", width: "12%", aspectRatio: "1", background: "#fff", p: "0.7mm", boxSizing: "border-box" }}>
                            <QRCodeCanvas value={item.id} size={160} style={{ width: "100%", height: "100%", display: "block" }} />
                        </Box>
                        <Box sx={{ position: "absolute", left: "16.2%", bottom: "5%", background: "#fff", color: "#111", fontWeight: 900, fontSize: "4.4mm", letterSpacing: "0.4mm", px: "1.6mm", py: "0.4mm", lineHeight: 1 }}>
                          {item.printNo}
                        </Box>

                  </Card>
                  );
                })
              ) : ( <Typography sx={{ p: 3, color: "#888" }}> Select a draw, enter how many coupons, then Apply. </Typography> )}
          </Box>

    
      </Container>

       {loading && <GradientLoader text="Loading" />}        {/* // loader */}
    </Box>
  );

}

export default LuckyDrawCoupon;